import {IApplicationState} from '../../../../../../types/types';
import {getNavigationPanelState} from './getNavigationPanelState';
import { getAsidePanelIsLeftPanelOpened } from 'app/view/react_components/aside_panel/asidePanel/store/selectors/getAsidePanelIsLeftPanelOpened';

export const isOpenNavigationPanelSelector = (
    state: IApplicationState
): boolean => {
    return getAsidePanelIsLeftPanelOpened(state) || getNavigationPanelState(state).isOpen;
};
